import React, { useEffect } from "react";
import { WarningOutlined } from "@ant-design/icons";
import { Modal, Typography, Input } from "antd";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { authValidate, authRequest } from "../../redux/actions/authAction";

const { Text, Paragraph } = Typography;

export default function ReactivateSession({ sessionExpired, clearSession }) {
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(120);
  const [oneTimePassword, setOneTimePassword] = useState(null);
  const [generateOTP, setGenerateOTP] = useState(false);
  const [loading, setLoading] = useState(false);
  let timer;

  const onSubmit = (value) => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setLoading(true);

    if (generateOTP) {
      if (!value) {
        setLoading(false);
        return;
      }
      dispatch(
        authValidate({
          emailAddress: userData.emailAddress,
          oneTimePassword: value,
        })
      )
        .then(() => {
          setLoading(false);
          window.location.reload();
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    } else {
      dispatch(
        authRequest({
          emailAddress: userData.emailAddress,
        })
      )
        .then(() => {
          setGenerateOTP(true);
          setLoading(false);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  };

  const handleOTPChange = (value) => {
    setOneTimePassword(value);
    if (value.length === 6) {
      // Assuming OTP is 6 digits
      onSubmit(value);
    }
  };

  const handleRegenerateOTP = () => {
    onSubmit(false);
  };

  const handleLogout = () => {
    clearInterval(timer);
    setCounter(0);
    clearSession();
  };

  useEffect(() => {
    if (sessionExpired) {
      const intervalTimer = setInterval(() => {
        setCounter((prev) => {
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(intervalTimer);
    }
  }, [sessionExpired]);

  useEffect(() => {
    if (counter <= 0) {
      clearSession();
    }
  }, [counter, clearSession]);

  return (
    <Modal
      title={
        <Text type="danger" strong>
          <WarningOutlined /> "Session Expired"
        </Text>
      }
      centered
      closable={false}
      maskClosable={false}
      destroyOnClose={true}
      open={sessionExpired}
      onOk={generateOTP ? () => onSubmit(oneTimePassword) : handleRegenerateOTP}
      onCancel={handleLogout}
      cancelText={"Logout" + (counter > 0 ? " (" + counter + ")" : "")}
      okText={generateOTP ? "Login" : "Regenerate OTP"}
      confirmLoading={loading}
    >
      <Paragraph>
        Your session has expired, kindly{" "}
        {generateOTP
          ? "enter one time password sent on your registered email address."
          : "generate one time password to resume session."}
      </Paragraph>
      {generateOTP && (
        <Input.OTP
          placeholder="One Time Password"
          onChange={handleOTPChange}
          size="large"
          style={{ width: "100%" }}
        />
      )}
    </Modal>
  );
}
